"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNoResultsText = exports.getLoadingPlaceholder = exports.enhanceProps = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = require("./styles");
var _components = require("./components");
var _reactSelect = require("react-select3");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var utilizeFastFilterOptions = function utilizeFastFilterOptions(props) {
  var enhancedProps = _objectSpread(_objectSpread({}, props), {}, {
    filterOptions: null
  });
  if (props.isSearchable) {
    enhancedProps.filterOptions = (0, _reactSelect.createFilter)({
      ignoreAccents: false
    });
  }
  return enhancedProps;
};
var enhanceProps = function enhanceProps(props) {
  var components = Object.assign({
    MultiValue: _components.MultiValue,
    DropdownIndicator: _components.DropdownIndicator,
    LoadingIndicator: _components.LoadingIndicator,
    ClearIndicator: _components.ClearIndicator
  }, props.components || {});
  var enhancedProps = _objectSpread(_objectSpread({}, props), {}, {
    isSearchable: props.isCreatable ? true : props.isSearchable,
    theme: _styles.Theme,
    className: (0, _classnames["default"])(props.className, 'sl-dropdown-container'),
    classNamePrefix: 'sl-dropdown',
    styles: props.hideDisabledOptions ? _objectSpread({}, _styles.dropdownHideDisabledOptionStyles) : _objectSpread({}, _styles.dropdownDefaultStyles),
    components: components,
    clearRenderer: _components.XIndicator
  });
  enhancedProps = utilizeFastFilterOptions(enhancedProps);
  return enhancedProps;
};
exports.enhanceProps = enhanceProps;
var getNoResultsText = function getNoResultsText(noOptionsMessage) {
  return noOptionsMessage ? noOptionsMessage() : undefined;
};
exports.getNoResultsText = getNoResultsText;
var getLoadingPlaceholder = function getLoadingPlaceholder(loadingMessage) {
  return loadingMessage ? loadingMessage() : undefined;
};
exports.getLoadingPlaceholder = getLoadingPlaceholder;